import {useState, useRef} from "react";
import { FiMenu } from "react-icons/fi";
import Logo from "../../elements/logo/Logo";
import Nav from './Nav';
import MobileMenu from './MobileMenu';
import { Link } from "react-scroll";
import Darkmode from "./Darkmode";
import useStickyHeader from "./useStickyHeader";
import { useTranslation } from "react-i18next";

const HeaderTwo = ({btnStyle, HeaderSTyle}) => {
    const { t } = useTranslation('academy');
    const [ofcanvasShow, setOffcanvasShow] = useState(false);
    const onCanvasHandler = () => {
        setOffcanvasShow(prev => !prev);
    }


    const ref = useRef();
    let [check] = useState(true);
    const sticky = useStickyHeader( 50 );
    const headerClasses = `header-default ${(sticky && check) ? 'sticky' : ''}`

    return (
        <>
            <header ref={ref} className={`rn-header header-default header-left-align ${HeaderSTyle} ${headerClasses}`}>
                <div className="container position-relative">
                    <div className="row align-items-center">
                        <div className="col-lg-2 col-md-6 col-4 position-static">
                            <div className="header-left d-flex">
                                <Logo 
                                    image={`${process.env.PUBLIC_URL}/acimages/logo/noizet-dark.png`}
                                    image2={`${process.env.PUBLIC_URL}/acimages/logo/noizet-light.png`}
                                />
                            </div>
                        </div>
                        <div className="col-lg-10 col-md-6 col-8">
                            <div className="header-right">
                                <nav className="mainmenu-nav d-none d-lg-block">
                                    <Nav />
                                </nav>
                                <div className="header-btn">
                                    <Link style={{cursor:'pointer'}} className={`btn-default ac-btn ${btnStyle}`} to="contactform" smooth={true} offset={-70} duration={500}>{t('footer.contact')}<i className="icon"></i></Link>
                                </div>
                                <div className="mobile-menu-bar ml--5 d-block d-lg-none">
                                    <div className="hamberger">
                                        <span className="hamberger-button" onClick={onCanvasHandler}><FiMenu /></span>
                                    </div>
                                </div>
                                <Darkmode />
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <MobileMenu show={ofcanvasShow} onClose={onCanvasHandler}  />
        </>
    )
}
export default HeaderTwo;